import { Instance } from 'mobx-state-tree';
import { RouteTimelineConstraintTimeWindowDtoModelBase } from './RouteTimelineConstraintTimeWindowDtoModel.base';

/* The TypeScript type of an instance of RouteTimelineConstraintTimeWindowDtoModel */
export interface RouteTimelineConstraintTimeWindowDtoModelType extends Instance<typeof RouteTimelineConstraintTimeWindowDtoModel.Type> {}

/* A graphql query fragment builders for RouteTimelineConstraintTimeWindowDtoModel */
export { selectFromRouteTimelineConstraintTimeWindowDto, routeTimelineConstraintTimeWindowDtoModelPrimitives, RouteTimelineConstraintTimeWindowDtoModelSelector } from './RouteTimelineConstraintTimeWindowDtoModel.base';

/**
 * RouteTimelineConstraintTimeWindowDtoModel
 */
export const RouteTimelineConstraintTimeWindowDtoModel = RouteTimelineConstraintTimeWindowDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
